// extracted by mini-css-extract-plugin
module.exports = {"containergeneral":"Options_containergeneral__re5Cf","imagecontainer":"Options_imagecontainer__3SLpZ","userGuide":"Options_userGuide__1kn-c"};